import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.set-prototype-of";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * Enhances a component with expandable behavior-handling for a
 * expandable container and togglers
 */
// TODO: move to separate react-component
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import uniqueId from 'lodash/uniqueId';
import styles from './expandable.module.less'; // these props will be added to the wrapped component
// We assume these props do not conflict with props of the
// wrapped component

var propTypes = {
  /**
   * These props are controlled.
   * This component will handle them, but you can set them
   * as well on the wrapped component as needed.
   */
  // gets/sets expanded container status
  expanded: PropTypes.bool,
  // outer container can be notified of toggle changes
  onExpandableToggle: PropTypes.func,

  /**
   * These props are controlled by the component.
   * They can be read, but cannot be set.
   */
  // spread these properties onto the component's popover container to add expandability
  // e.g. <div {...props.expandableContainerProps}>
  expandableContainerProps: PropTypes.shape({
    // adds expanded styles as needed
    className: PropTypes.string,
    // ensures an id for toggle ARIA linkage
    id: PropTypes.string,
    // communicates ARIA expanded state
    'aria-expanded': PropTypes.oneOf(['true', 'false']),
    // tracks escape functionality when expanded
    ref: PropTypes.func
  }),
  // spread these props onto any element that should trigger popover
  // e.g. <button {...props.expandableToggleProps}>
  expandableToggleProps: PropTypes.shape({
    onClick: PropTypes.func,
    'aria-controls': PropTypes.string,
    'aria-expanded': PropTypes.oneOf(['true', 'false'])
  }),
  // component can trigger toggle manually
  handleExpandableToggle: PropTypes.func
};
var defaultProps = {
  expanded: false,
  expandableContainerProps: {},
  expandableToggleProps: {},
  onExpandableToggle: function onExpandableToggle() {},
  handleExpandableToggle: function handleExpandableToggle() {}
};
var ESCAPE_KEY = 27;
/**
 * Enhances a component with expandable behavior-handling for a
 * expandable container and togglers
 * @param  {Component} ComponentToEnhance Component to enhance
 * @return {Component} enhanced component
 */

var expandable = function expandable(ComponentToEnhance) {
  var Expandable =
  /*#__PURE__*/
  function (_Component) {
    _inherits(Expandable, _Component);

    function Expandable(props) {
      var _this;

      _classCallCheck(this, Expandable);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(Expandable).call(this, props));
      var expanded = props.expanded;
      _this.createRef = _this.createRef.bind(_assertThisInitialized(_this));
      _this.handleEscape = _this.handleEscape.bind(_assertThisInitialized(_this));
      _this.handleToggle = _this.handleToggle.bind(_assertThisInitialized(_this));
      _this.handleOutsideClick = _this.handleOutsideClick.bind(_assertThisInitialized(_this));
      _this.state = {
        // tracks expanded/close status
        expanded: expanded,
        // primer for a expandable container id
        id: null
      };
      return _this;
    }

    _createClass(Expandable, [{
      key: "componentWillMount",
      value: function componentWillMount() {
        var _this$props$id = this.props.id,
            id = _this$props$id === void 0 ? uniqueId() : _this$props$id; // ensure expandable will have an ID so triggers can control it

        this.setState({
          id: "".concat(id || uniqueId(), "__expandable")
        });
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        var expanded = this.state.expanded;

        if (expanded) {
          this.listenForEscape();
        }
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(_prevProps, prevState) {
        var wasExpanded = prevState.expanded;
        var isExpanded = this.state.expanded; // only manage listeners if we just expanded or closed

        var expanded = !wasExpanded && isExpanded;
        var closed = wasExpanded && !isExpanded;

        if (expanded) {
          this.listenForEscape();
        } else if (closed) {
          this.ignoreEscape();
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.ignoreEscape();
      }
    }, {
      key: "handleEscape",
      value: function handleEscape(e) {
        if (e.keyCode === ESCAPE_KEY) {
          this.handleToggle(e);
        }
      }
      /** fires toggle for any mouse event outside of popover  */

    }, {
      key: "handleOutsideClick",
      value: function handleOutsideClick(e) {
        // ignore if clicked inside
        if (this.popover.contains(e.target)) {
          return;
        } // otherwise, close


        this.handleToggle(e);
      }
      /** handles a listened primary mousedown, toggling the popover. ignores following click */

    }, {
      key: "handleToggle",
      value: function handleToggle(e) {
        var onExpandableToggle = this.props.onExpandableToggle;
        var _e$nativeEvent = e.nativeEvent;
        _e$nativeEvent = _e$nativeEvent === void 0 ? {} : _e$nativeEvent;
        var which = _e$nativeEvent.which,
            target = e.target;
        var expanded = this.state.expanded;
        var primaryButton = which === 1;
        var expandeding = !expanded; // will this handle expanded the popover?
        // ignore anything other than "left mouse button"

        if (which && !primaryButton) {
          return;
        }

        e.preventDefault();

        if (expandeding && target) {
          // remember last toggle for refocus, and ensure it stays focused
          this.toggler = target;
          this.toggler.focus();
        } else if (this.toggler) {
          // focus back on toggler if still there
          this.toggler.focus();
        } // toggle the popover state


        this.setState({
          expanded: expandeding
        }); // alert any listeners on the component

        onExpandableToggle(e);
      }
    }, {
      key: "listenForEscape",
      value: function listenForEscape() {
        // listen for these events for toggling the popover
        // use capture to ensure outer clicks fire first instead of bubble up
        document.addEventListener('keydown', this.handleEscape, true); // we want toggle behavior to happen

        document.addEventListener('click', this.handleOutsideClick, true);
      }
    }, {
      key: "ignoreEscape",
      value: function ignoreEscape() {
        // remove listeners
        document.removeEventListener('keydown', this.handleEscape, true);
        document.removeEventListener('click', this.handleOutsideClick, true);
      }
    }, {
      key: "createRef",
      value: function createRef(el) {
        this.popover = el;
      }
    }, {
      key: "render",
      value: function render() {
        var _this$state = this.state,
            expanded = _this$state.expanded,
            id = _this$state.id;
        var expandableContainerProps = {
          'aria-expanded': expanded.toString(),
          className: classNames(styles.container, styles.popover, _defineProperty({}, styles.expanded, expanded)),
          id: id,
          ref: this.createRef,
          tabIndex: -1
        };
        var expandableToggleProps = {
          'aria-controls': id,
          'aria-expanded': expanded.toString(),
          onClick: this.handleToggle
        };
        return React.createElement(ComponentToEnhance, _extends({}, this.props, {
          expanded: expanded,
          expandableContainerProps: expandableContainerProps,
          expandableToggleProps: expandableToggleProps,
          handleExpandableToggle: this.handleToggle
        }));
      }
    }]);

    return Expandable;
  }(Component);

  var getDisplayName = function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  };

  Expandable.displayName = "Expandable(".concat(getDisplayName(ComponentToEnhance), ")");
  Expandable.propTypes = _objectSpread({}, ComponentToEnhance.propTypes, propTypes);
  Expandable.defaultProps = _objectSpread({}, ComponentToEnhance.defaultProps, defaultProps);
  return Expandable;
};

expandable.propTypes = propTypes;
expandable.defaultProps = defaultProps;
export default expandable;